import { useQuery } from '@tanstack/react-query';

import recipeFlow from '../flow/recipeFlow';
import { recipeQueryKeys } from '../recipeQueries';

export const useRecipeByExternalIdQuery = (recipeExternalId: string) => {
    const query = useQuery({
        queryKey: recipeQueryKeys.byExternalId(recipeExternalId!),
        queryFn: async () => recipeFlow.getRecipeById(recipeExternalId!),
        enabled: !!recipeExternalId,
        staleTime: 60 * 10 * 1000, // 10 minutes
        retry: 1,
    });

    return query;
};
